// src/pages/SolicitarReset.js
//
// Paso 1 del reset de contraseña: pedimos el correo. El backend envía
// un link al correo si existe (respuesta neutra por seguridad).

import React, { useState } from 'react';
import {
  Box, Container, Card, CardContent, TextField, Button, Typography, Stack,
  Alert, IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Logo from '../components/Logo';
import { solicitarReset } from '../api/authApi';

export default function SolicitarReset() {
  const navigate = useNavigate();
  const [correo, setCorreo]     = useState('');
  const [enviado, setEnviado]   = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError]       = useState('');

  const enviar = async (e) => {
    e?.preventDefault?.();
    setError('');
    if (!correo.trim()) {
      setError('Escribe tu correo.');
      return;
    }
    setCargando(true);
    try {
      await solicitarReset(correo.trim());
      setEnviado(true);
    } catch (err) {
      setError(err.mensajeUsuario || 'No se pudo enviar la solicitud.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FBF7F0', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="lg" sx={{ py: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton onClick={() => navigate('/login')} aria-label="Volver al login">
          <ArrowBackIcon />
        </IconButton>
        <Logo />
      </Container>

      <Container maxWidth="sm" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', py: 4 }}>
        <Card sx={{ width: '100%' }}>
          <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
            <Typography variant="overline" color="text.secondary">Recuperar acceso</Typography>
            <Typography variant="h4" sx={{ fontFamily: 'Fraunces', mb: 1 }}>
              ¿Olvidaste tu contraseña?
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              Escribe el correo con el que te registraste. Si existe una cuenta asociada,
              te enviaremos un enlace para crear una contraseña nueva.
            </Typography>

            {enviado ? (
              <>
                <Alert severity="success" sx={{ mb: 2 }}>
                  Si el correo existe, recibirás un enlace en unos minutos. Revisa
                  también la carpeta de spam.
                </Alert>
                <Button variant="outlined" fullWidth onClick={() => navigate('/login')}>
                  Volver al login
                </Button>
              </>
            ) : (
              <form onSubmit={enviar}>
                <Stack spacing={2.5}>
                  <TextField
                    label="Correo electrónico"
                    type="email"
                    value={correo}
                    onChange={(e) => setCorreo(e.target.value)}
                    autoFocus
                    fullWidth
                  />
                  {error && <Alert severity="error">{error}</Alert>}
                  <Button type="submit" variant="contained" size="large" fullWidth disabled={cargando}>
                    {cargando ? 'Enviando…' : 'Enviar enlace'}
                  </Button>
                </Stack>
              </form>
            )}
          </CardContent>
        </Card>
      </Container>

      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="caption" color="text.secondary">
          HolaVeci · Redeprog SAS
        </Typography>
      </Box>
    </Box>
  );
}
